import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Menu } from '@one-thd/sui-atomic-components';
import { ArrowDown } from '@one-thd/sui-icons';
import Dropdown from './Dropdown';
import useClickAway from '../../hooks/useClickAway';

const Filter = (props) => {
  const {
    type, filters, selectedFilters, onChange, containerId, isMobile
  } = props;
  const [visible, setTooltipVisible] = useState(false);
  const filterContainer = document.getElementById(containerId);
  const ref = useRef();
  const anchorRef = useRef(null);

  const spanIconClasses = classNames(
    'sui-flex sui-ml-4 sui-transition-transform sui-duration-250',
    'group-focus-visible:sui-fill-inverse group-hover:sui-fill-brand',
    {
      'sui-fill-primary': !visible,
      'sui-rotate-180 sui-fill-brand': visible
    }
  );

  const onClickAway = () => {
    setTooltipVisible(false);
  };

  useClickAway({ ref, onClickAway });

  const onClick = (event) => {
    event.preventDefault();
    setTooltipVisible(!visible);
  };

  const handleOnChange = (val) => {
    if (!val) {
      return;
    }
    setTooltipVisible(false);
    onChange(type, val);
  };

  const renderFilterButton = () => {
    return (
      <div
        className="sui-inline-flex sui-items-center sui-relative sui-z-10"
        data-testid={isMobile ? 'filter-btn-wrapper-mobile' : 'filter-btn-wrapper'}
      >
        <Button
          className="sui-group
          sui-inline-flex
          sui-items-center
          sui-px-3
          sui-py-2
          sui-justify-between
          sui-font-regular
          sui-text-base
          sui-leading-tight
          sui-h-11
          sui-w-52
          sui-rounded-base
          sui-border-solid
          sui-border-1
          focus-visible:sui-text-inverse
          focus-visible:sui-bg-inverse
          focus-visible:sui-outline
          focus-visible:sui-outline-4
          focus-visible:sui-outline-input-focus
          sui-border-strong
          hover:sui-border-input-hover
          "
          onClick={onClick}
          data-testid="filter-btn"
          ref={anchorRef}
        >
          <span className="sui-capitalize">{type}</span>
          <span className={spanIconClasses}>
            <ArrowDown size="small" color="inherit" />
          </span>
        </Button>
      </div>
    );
  };

  const renderDropdown = () => {
    return (
      <Dropdown
        filters={filters}
        onChange={handleOnChange}
        selectedFilters={selectedFilters}
        lengthLimit={isMobile ? 5 : 10}
        isMobile={isMobile}
      />
    );
  };

  if (!filters || !filters.length) {
    return null;
  }

  if (isMobile) {
    return (
      <>
        {renderFilterButton()}
        {visible
          && filterContainer
          && createPortal(
            <div
              className="sui-w-full sui-rounded-base
          sui-border-solid
          sui-border-1
          sui-mt-2
          "
              ref={ref}
            >
              {renderDropdown()}
            </div>,
            filterContainer
          )}
      </>
    );
  }

  return (
    <>
      {renderFilterButton()}
      <Menu
        open={visible}
        anchorEl={anchorRef.current}
        onClose={onClickAway}
        PaperProps={{
          className: 'sui-z-20 sui-w-52 sui-border-strong sui-rounded-b-base'
        }}
      >
        {renderDropdown()}
      </Menu>
    </>
  );
};

Filter.propTypes = {
  type: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  containerId: PropTypes.string,
  selectedFilters: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool
};

Filter.defaultProps = {
  selectedFilters: [],
  containerId: 'root',
  isMobile: false
};

export default Filter;
